// extracted by mini-css-extract-plugin
export default {"addToCartModalBody":"add-to-cart-modal-body___V779V","cancelCta":"cancelCta___iAwPU","acceptCta":"acceptCta___foS7B"};